import api from '@/helpers/api'
import helpers from '@/helpers'
import i18n from '@/plugins/i18n'
import store from '@/store'
import auth from '@/auth'

export default {

  /**
   * Edit user information
   * @param {Integer} userId
   * @param {Object} data - edited data of the user
   */
  async editUser(userId, data) {
    const apiSettings = {
      method: 'put',
      service: 'users',
      url: `v1/users/${userId}`,
      data: data
    }

    try {
      await api.promise(apiSettings)
      store.dispatch('setSystemMessage', null)
    } catch (error) {
      throw new Error(error[0].message)
    }
  },
  async fetchAccountRoleOptions() {
    if (!auth.isParkmanAdmin()) {
      const response = await api.promise({
        method: 'get',
        service: 'merchant',
        url: 'merchants/account-roles'
      })
      store.dispatch('setAccountRoleOptions', response.data)
    }
  },

  /**
   * Fetch all system-supported roles for user
   */
  async fetchRoleOptions() {
    store.dispatch('setSystemMessage', {
      message: `${i18n.t('loading_role')}...`,
      type: 'success',
      once: true
    })

    // redirect to home page if no user found
    let userId = ''
    try {
      userId = helpers.getTokenInfo().uid
    } catch (exception) {
      window.location.href = '/'
    }

    const apiSettings = {
      method: 'get',
      service: 'users',
      url: `v1/users/${userId}/roles`
    }

    try {
      const response = await api.promise(apiSettings)
      const roles = response.user_roles

      await store.dispatch('setRoleOptions', roles)
      store.dispatch('setSystemMessage', null)

      return roles
    } catch (error) {
      store.dispatch('setSystemMessage', error)
    }
  },

  /**
   * Get driver role id
   */
  getDriverRoleId() {
    const roleOptions = store.state.roleOptions
    const role = roleOptions.find((item) => item.name === 'driver')
    return role.id
  },

  /**
   * Get company admin role id
   */
  getCompanyAdminRoleId() {
    const roleOptions = store.state.roleOptions
    const role = roleOptions.find((item) => item.name === 'company_admin')
    return role.id
  },

  /**
   * Get role name by its id
   * @param {Integer} role id
   * return Driver by default
   */
  getRoleTextById(roleId) {
    const defaultValue = i18n.t('role_driver')
    if (!roleId) {
      return defaultValue
    }

    const roleOptions = store.state.roleOptions
    if (!roleOptions) {
      return defaultValue
    }

    const role = roleOptions.find((item) => item.id === roleId)

    return role ? i18n.t(`role_${role.name}`) : defaultValue
  },

  /**
   * Check if the employee will have a change in pricing in the next month
   */
  doesEmployeeHavePricingUpdate(employee) {
    if (!employee.subscription) {
      return false
    }

    const subscription = employee.subscription
    if (!subscription.next_account_package) {
      return false
    }

    // when the employee subscribes to the same package, check if package has incoming change
    if (
      subscription.next_account_package_id === subscription.account_package_id
    ) {
      return subscription.next_account_package.package.prices[0].pending_update
    }

    return true
  }

  // @todo (Hieu): fetch companies and check if have at least 1 company with role enterprise admin
  // if yes, store companies in store & return true
  // otherwise, return false
}
